import React from "react";
import Upload from "rc-upload";
import Fa from "../common/Fa";

/**
 * Componente que se encarga manejar la carga de archivos.
 */
export default class File extends React.Component {
  state = {
    fileName: "",
    loading: false,
    error: false
  };

  uploaderProps = {
    action: "/api/v1/upload",
    multiple: true,
    accept: this.props.accept,
    beforeUpload: file => {
      //this.setState({ fileName: file.name });
    },

    onStart: file => {
      this.setState({ fileName: file.name, loading: true, error: false });
    },

    onSuccess: file => {
      this.props.onChange(file);
      console.log("onSuccess", file);
    },

    onError: err => {
      this.setState({ loading: false, error: true });
      console.log("onError", err);
    }
  };

  /**
   * Se ecnarga de renderizar el componente
   */
  render() {
    return (
      <div className="field">
        <Upload {...this.uploaderProps} ref="inner">
          <a className="button">
            <Fa icon="upload" />
            &nbsp; {this.props.label}
          </a>
          &nbsp;
          <small>
            {this.state.fileName}
            {this.state.loading && <i className="fas fa-spinner fa-spin" />}
          </small>
        </Upload>
        <p className="help">{this.props.help}</p>
      </div>
    );
  }
}
